export enum CreatorUserStatus {
  PRESENT = 'present',
  HIDDEN = 'hidden',
  REMOVED = 'removed'
}